import { ImageElementType, RichTextElement } from './TabStateInterfaces';

//1
export const addTab = (tabId: number, tabName?: string) => {
  return {
    type: 'ADD_TAB',
    payload: { tabId, tabName },
  };
};

//2
export const removeTab = (tabName: string, tabId: number, tabToRemoveIndex: number) => {
  return {
    type: 'REMOVE_TAB',
    payload: { tabName: tabName, tabId: tabId, tabToRemoveIndex: tabToRemoveIndex },
  };
};
//3
export const renameTab = (renameValue: string, tabId: number) => {
  return {
    type: 'RENAME_TAB',
    payload: {
      renameValue: renameValue,
      tabId: tabId,
    },
  };
};
//4
export const updateNextTileId = (nextTileId: number, tabId: number) => {
  return {
    type: 'UPDATE_NEXT_TILE_ID',
    payload: {
      nextTileId: nextTileId,
      tabId: tabId,
    },
  };
};

//5
export const updateSelectedTileToTab = (tabId: number, tileName: string, tileId: number) => {
  return {
    type: 'SELECTED_TILE_IN_TAB',
    payload: {
      tabId: tabId,
      tileName: tileName,
      tileId: tileId,
    },
  };
};
//6
export const showDashboardInTab = (tabId: number, showDash: boolean) => {
  return { type: 'SHOW_DASHBOARD_IN_TAB', payload: { tabId, showDash } };
};

//7
export const toggleDashModeInTab = (tabId: number, dashMode: string) => {
  return { type: 'TOGGLE_DASH_MODE_IN_TAB', payload: { tabId, dashMode } };
};

//8
export const updateTabDashDetails = (
  checked: boolean,
  propKey: string,
  dashSpecs: any,
  tabId: number,
  propIndex: number,
) => {
  return {
    type: 'UPDATE_DASH_GRAPH_DETAILS',
    payload: { checked, propKey, dashSpecs, tabId, propIndex },
  };
};

//9
export const removeTilesInDashDuringDeleteTile = (tabId: number, propKey: string) => {
  return { type: 'REMOVE_TILES_IN_DASH_DURING_DELETE_TILE', payload: { tabId, propKey } };
};
//10
export const updateDashGraphPosition = (tabId: number, propKey: string, x: any, y: any) => {
  return { type: 'UPDATE_DASH_GRAPH_POSITION', payload: { tabId, propKey, x, y } };
};
//11
export const updateDashGraphSize = (
  tabId: number,
  propKey: string,
  x: any,
  y: any,
  width: any,
  height: any,
  isAutoReflow?: boolean,
) => {
  return {
    type: 'UPDATE_DASH_GRAPH_SIZE',
    payload: { tabId, propKey, x, y, width, height, isAutoReflow },
  };
};

//14
export const setDashLayout = (tabId: number, value: any) => {
  return { type: 'SET_DASHLAYOUT', payload: { tabId, value } };
};
//15
export const setDashLayoutSelectedOptionForAuto = (tabId: number, value: any) => {
  return { type: 'SET_DASHLAYOUT_SELECTEDOPTION_FOR_AUTO', payload: { tabId, value } };
};

//16
export const setAspectRatioHeight = (tabId: number, value: any) => {
  return { type: 'SET_ASPECTRATIO_HEIGHT', payload: { tabId, value } };
};
//17
export const setAspectRatioWidth = (tabId: number, value: any) => {
  return { type: 'SET_ASPECTRATIO_WIDTH', payload: { tabId, value } };
};
//18
export const setCustomHeight = (tabId: number, value: any) => {
  return { type: 'SET_CUSTOM_HEIGHT', payload: { tabId, value } };
};
//19
export const setCustomWidth = (tabId: number, value: any) => {
  return { type: 'SET_CUSTOM_WIDTH', payload: { tabId, value } };
};
//20
export const setCustomRMaxWidth = (tabId: number, value: any) => {
  return { type: 'SET_CR_MAX_WIDTH', payload: { tabId, value } };
};
//21
export const setCustomRMinWidth = (tabId: number, value: any) => {
  return { type: 'SET_CR_MIN_WIDTH', payload: { tabId, value } };
};
//22
export const setCustomRMaxHeight = (tabId: number, value: any) => {
  return { type: 'SET_CR_MAX_HEIGHT', payload: { tabId, value } };
};

//23
export const setCustomRMinHeight = (tabId: number, value: any) => {
  return { type: 'SET_CR_MIN_HEIGHT', payload: { tabId, value } };
};

//24
export const setDashLayoutSelectedOptionForFixed = (tabId: number, value: any) => {
  return { type: 'SET_DASHLAYOUT_SELECTEDOPTION_FOR_FIXED', payload: { tabId, value } };
};

//25
export const loadTabState = (tabState: any) => {
  return { type: 'LOAD_TAB_STATE_FROM_PLAYBOOK', payload: tabState };
};
//26

export const resetTabState = () => {
  return { type: 'RESET_TAB_STATE' };
};

export const resetGraphHighlight = (tabId: any) => {
  return { type: 'RESET_GRAPH_BORDER_HIGHLIGHT', payload: { tabId } };
};

export const updateGraphHighlight = (tabId: number, propKey: string, highlight: any) => {
  return { type: 'SET_GRAPH_BORDER_HIGHLIGHT', payload: { tabId, propKey, highlight } };
};

export const setTheme = (theme: string, tabId: number) => {
  return {
    type: 'SET_THEME',
    payload: { theme, tabId },
  };
};

export const setThemeId = (themeId: string, tabId: number) => {
  return {
    type: 'SET_THEME_ID',
    payload: { themeId, tabId },
  };
};

export const setDashColorScheme = (colorScheme: string, tabId: number) => {
  return { type: 'SET_COLOR_SCHEME', payload: { colorScheme, tabId } };
};

export const toggleAllTiles = (tabId: number) => {
  return {
    type: 'TOGGLE_ALL_TILES',
    payload: { tabId },
  };
};

export const setDefaultThemeId = (tabId: number, themeId: string | null) => {
  return {
    type: 'SET_DEFAULT_THEME_ID',
    payload: { tabId, themeId },
  };
};

export const toggleAllTabs = (tabId: number) => {
  return {
    type: 'TOGGLE_ALL_TABS',
    payload: { tabId },
  };
};

// Action creators for resolution settings

export const setResolutionType = (tabId: number, value: string) => {
  return { type: 'SET_RESOLUTION_TYPE', payload: { tabId, value } };
};

export const setResolution = (tabId: number, value: string) => {
  return { type: 'SET_RESOLUTION', payload: { tabId, value } };
};

export const setAutoScalingWidth = (tabId: number, value: string) => {
  return { type: 'SET_AUTO_SCALING_WIDTH', payload: { tabId, value } };
};

export const setAutoScalingHeight = (tabId: number, value: string) => {
  return { type: 'SET_AUTO_SCALING_HEIGHT', payload: { tabId, value } };
};

export const setDashboardHeight = (tabId: number, value: number) => {
  return { type: 'SET_DASHBOARD_HEIGHT', payload: { tabId, value } };
};

export const setDashboardRows = (tabId: number, value: number) => {
  return { type: 'SET_DASHBOARD_ROWS', payload: { tabId, value } };
};

export const toggleThemeState = (tabId: number) => {
  return {
    type: 'TOGGLE_THEME_STATE',
    payload: { tabId },
  };
};

export const updateHoveredItems = (
  tabId: number,
  colItems: Record<string, any>[],
  propKey: string,
) => {
  return {
    type: 'UPDATE_HOVERED_ITEMS',
    payload: { tabId, colItems, propKey },
  };
};

//image Elements actions
export const addImageElement = (tabId: number, newElement: ImageElementType) => ({
  type: 'ADD_IMAGE_ELEMENT',
  payload: {
    tabId,
    newElement,
  },
});

export const setSelectedImageId = (tabId: number, id: string | null) => ({
  type: 'SET_SELECTED_IMAGE_ID',
  payload: {
    tabId,
    selectedImageId: id,
  },
});

export const setImageElements = (tabId: number, elements: ImageElementType[]) => ({
  type: 'SET_IMAGE_ELEMENTS',
  payload: {
    tabId,
    imageElements: elements,
  },
});

export const updateImageElement = (
  tabId: number,
  id: string,
  updates: Partial<ImageElementType>,
) => ({
  type: 'UPDATE_IMAGE_ELEMENT',
  payload: {
    tabId,
    id,
    updates,
  },
});

export const removeImageElement = (tabId: number, id: string) => ({
  type: 'REMOVE_IMAGE_ELEMENT',
  payload: { tabId, id },
});

export const updateImagePosition = (
  tabId: number,
  id: string,
  x: number,
  y: number,
  isAutoReflow?: boolean,
) => ({
  type: 'UPDATE_IMAGE_POSITION',
  payload: { tabId, id, x, y, isAutoReflow },
});

export const updateImageSize = (
  tabId: number,
  id: string,
  width: number,
  height: number,
  x: number,
  y: number,
  isAutoReflow?: boolean,
) => ({
  type: 'UPDATE_IMAGE_SIZE',
  payload: { tabId, id, width, height, x, y, isAutoReflow },
});

export const setHoveredTile = (propKey: string) => {
  return {
    type: 'SET_HOVERED_TILE',
    payload: propKey,
  };
};

export const clearHoveredTile = () => {
  return {
    type: 'CLEAR_HOVERED_TILE',
  };
};

export const setSelectedTile = (propKey: string | null) => {
  return {
    type: 'SET_SELECTED_TILE',
    payload: propKey,
  };
};

// Rich Text Element Actions
export const addRichTextElement = (tabId: number, newElement: RichTextElement) => ({
  type: 'ADD_RICH_TEXT_ELEMENT',
  payload: {
    tabId,
    newElement,
  },
});
export const removeRichTextElement = (tabId: number, id: string) => ({
  type: 'REMOVE_RICH_TEXT_ELEMENT',
  payload: { tabId, id },
});
export const updateRichTextElement = (
  tabId: number,
  id: string,
  updates: Partial<RichTextElement>,
) => ({
  type: 'UPDATE_RICH_TEXT_ELEMENT',
  payload: {
    tabId,
    id,
    updates,
  },
});
export const updateRichTextPosition = (
  tabId: number,
  id: string,
  x: number,
  y: number,
  isAutoReflow?: boolean,
) => ({
  type: 'UPDATE_RICH_TEXT_POSITION',
  payload: { tabId, id, x, y, isAutoReflow },
});

export const updateRichTextSize = (
  tabId: number,
  id: string,
  width: number,
  height: number,
  x: number,
  y: number,
  isAutoReflow?: boolean,
) => ({
  type: 'UPDATE_RICH_TEXT_SIZE',
  payload: { tabId, id, width, height, x, y, isAutoReflow },
});

export const setSelectedRichTextId = (tabId: number, id: string | null) => ({
  type: 'SET_SELECTED_RICH_TEXT_ID',
  payload: { tabId, selectedRichTextId: id },
});

export const toggleTabHidden = (tabId: number, id?: string | null) => {
  console.log('ACTION CREATOR FIRED for tab:', tabId);
  return {
    type: 'TOGGLE_TAB_HIDDEN',
    payload: { tabId },
  };
};

export const setAllTileBorder = (payload: {
  tabId: number;
  borderProperties?: { color: string; width: number; borderRadius: number } | null;
}) => {
  return {
    type: 'SET_ALL_TILE_BORDER',
    payload,
  };
};
export const updateAllTileBorder = (payload: {
  tabId: number;
  borderProperties?: { color: string; width: number; borderRadius: number } | null;
}) => {
  return {
    type: 'UPDATE_ALL_TILE_BORDER',
    payload,
  };
};
export const removeAllTileBorder = (payload: { tabId: number }) => {
  return {
    type: 'REMOVE_ALL_TILE_BORDER',
    payload,
  };
};

export const toggleMouseOverInteractivity = (payload: { tabId: number }) => {
  return {
    type: 'TOGGLE_MOUSEOVER_INTERACTIVITY',
    payload,
  };
};

export const reOrderTabList = (moveAction: string, tabIndex: number) => {
  return {
    type: 'REORDER_TAB',
    payload: { moveAction, tabIndex },
  };
};

export const setFontFamily = (tabId: number, fontFamily: string) => {
  return {
    type: 'SET_FONT_FAMILY',
    payload: { tabId, fontFamily },
  };
};

export const setFontFamilyForAllTiles = (tabId: number, fontFamilyForAllTiles: boolean) => {
  return {
    type: 'SET_FONT_FAMILY_FOR_ALL_TILES',
    payload: { tabId, fontFamilyForAllTiles },
  };
};

export const setTilesColorSchemeToDashboardScheme = (tabId: number, tilesTodashboard: boolean) => {
  return {
    type: 'SET_TILES_COLOR_SCHEME_TO_DASHBOARD_SCHEME',
    payload: { tabId, tilesTodashboard },
  };
};

//filter related actions
export const setFilterVisibilityMode = (tabId: number, filterVisibilityMode: string) => {
  return {
    type: 'SET_FILTER_VISIBILITY_MODE',
    payload: { tabId, filterVisibilityMode },
  };
};

export const setFilterPanelMode = (tabId: number, filterPanelMode: string) => {
  return {
    type: 'SET_FILTER_PANEL_MODE',
    payload: { tabId, filterPanelMode },
  };
};

export const resetCustomLayout = (tabId: number) => {
  return {
    type: 'RESET_CUSTOM_LAYOUT',
    payload: { tabId },
  };
};
